export var pathFile = "ws://182.150.6.137:8081/hawkeye/";
// export var pathFile = "ws://192.168.1.254:8081/hawkeye_ll/";
